import { useFallbackTheme } from '@src/hooks/useFallbackTheme';
import { logger, WLOrgConfigProvider } from '@talos/kyoko';
import { useRouteError } from 'react-router-dom';
import styled, { ThemeProvider } from 'styled-components';
import { ErrorBoundaryDisplay } from './ErrorBoundaryDisplay';

const RouterErrorBoundaryWrapper = styled.div`
  width: 100vw;
  width: 100dvw;
  height: 100vh;
  height: 100dvh;
  background: ${({ theme }) => theme.backgroundContent};
`;

/** React Router-level Error Boundary (not caught by any internal ErrorBoundary) */
export const ErrorBoundaryRouted = () => {
  return (
    <WLOrgConfigProvider>
      <ErrorBoundaryRouterInner />
    </WLOrgConfigProvider>
  );
};

const ErrorBoundaryRouterInner = () => {
  // Since this is a fallout error, we use the common Theme fallback used in unauthorized cases
  const theme = useFallbackTheme();
  const error = useRouteError();
  logger.error(error as Error);
  return !theme ? null : (
    <ThemeProvider theme={theme}>
      <RouterErrorBoundaryWrapper>
        <ErrorBoundaryDisplay />
      </RouterErrorBoundaryWrapper>
    </ThemeProvider>
  );
};
